import React, { useEffect } from "react";
import { getDesignById } from "../../../api/design/service";
import { looksLikePdf } from "./DesignShared";
import PdfDetailView from "./PdfDetailView";
import ImageDetailView from "./ImageDetailView";

export default function DrawingDetailView({
  drawing,
  onBack,
  onUpdate,
  onDelete,
  currentMember,
}) {
  // Always hydrate the selected design from the retrieve endpoint.
  // This is critical for blob/SAS setups where the file URL can change after replace.
  useEffect(() => {
    let mounted = true;
    (async () => {
      if (!drawing?.id) return;
      try {
        const fresh = await getDesignById(drawing.id);
        if (!mounted) return;
        onUpdate?.((prev) => ({ ...(prev || drawing), ...(fresh || {}) }));
      } catch (_) {
        // ignore; best-effort hydration
      }
    })();
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawing?.id]);

  const isPdf = looksLikePdf(drawing?.diagram);
  if (isPdf) {
    return (
      <PdfDetailView
        drawing={drawing}
        onBack={onBack}
        onUpdate={onUpdate}
        onDelete={onDelete}
        currentMember={currentMember}
      />
    );
  }
  return (
    <ImageDetailView
      drawing={drawing}
      onBack={onBack}
      onUpdate={onUpdate}
      onDelete={onDelete}
      currentMember={currentMember}
    />
  );
}